let Environment = {
mintContract:"0x636e1427c90d43f518b5b1a92bf4a9e11fb51f97"
  // mintContract: "0x636e1427c90d43f518b5b1a92bf4a9e11fb51f97"
  // "0x513Cfd729DeEadd4BBfB8Cb5014e6C63d67a787a",

  // ethContract: "0x495f947276749Ce646f68AC8c248420045cb7b5e",

  // 0xfBdA3CBC52Efd4fD83679066CCC6524DfBd2328A
};

export default Environment;
